import { Classes, Colors, IconSize } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'src/components/icons/types';
import { GeometryString } from 'src/containers/ProjectDiagram/constants/geometries';

export const Unlink: React.VFC<IconProps> = ({
  className,
  color = Colors.GRAY1,
  iconSize = IconSize.STANDARD,
}) => (
  <svg
    className={classNames('sd-icon', Classes.ICON, className)}
    fill="none"
    height={iconSize}
    viewBox="0 0 60 60"
    width={iconSize}
  >
    <path
      clipRule="evenodd"
      d={GeometryString.UNLINK}
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
